import React from 'react';
import { Dropdown } from 'antd';
import './sim-manager-header.css';

/**
 * SimManagerHeader — хедер страницы Sim-менеджер
 * По макету Figma 26-04 wa Proxy Manager (node 383-69908)
 * ТОЧНОЕ соответствие макету
 */

const RefreshIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_smh_refresh)">
      <path d="M6.0001 0.999894C6.66336 1.00207 7.31959 1.13576 7.93084 1.39324C8.54208 1.65071 9.09619 2.02685 9.5611 2.49989H8.0001C7.86749 2.49989 7.74032 2.55257 7.64655 2.64634C7.55278 2.74011 7.5001 2.86729 7.5001 2.99989C7.5001 3.1325 7.55278 3.25968 7.64655 3.35345C7.74032 3.44722 7.86749 3.49989 8.0001 3.49989H10.0716C10.3178 3.49976 10.5539 3.4019 10.728 3.2278C10.9021 3.0537 11 2.81761 11.0001 2.57139V0.499894C11.0001 0.367286 10.9474 0.240109 10.8537 0.14634C10.7599 0.0525723 10.6327 -0.000106158 10.5001 -0.000106158C10.3675 -0.000106158 10.2403 0.0525723 10.1465 0.14634C10.0528 0.240109 10.0001 0.367286 10.0001 0.499894V1.53889C9.17369 0.79462 8.15639 0.295099 7.06215 0.0962684C5.96791 -0.102562 4.83991 0.00714982 3.80449 0.413118C2.76907 0.819085 1.86711 1.50528 1.19961 2.39486C0.532105 3.28443 0.125422 4.34227 0.0251013 5.44989C0.0186429 5.51952 0.0267591 5.58973 0.0489327 5.65605C0.0711063 5.72237 0.106851 5.78334 0.153889 5.83509C0.200928 5.88683 0.258228 5.92821 0.32214 5.95658C0.386052 5.98496 0.455174 5.99971 0.525101 5.99989C0.647395 6.00145 0.765868 5.95731 0.857331 5.87612C0.948793 5.79492 1.00666 5.68251 1.0196 5.56089C1.13091 4.31627 1.70359 3.15825 2.62514 2.31431C3.54669 1.47038 4.75051 1.00154 6.0001 0.999894Z" fill="currentColor"/>
      <path d="M11.4756 6.00004C11.3533 5.99848 11.2349 6.04262 11.1434 6.12382C11.0519 6.20501 10.9941 6.31742 10.9811 6.43904C10.8985 7.39066 10.5446 8.2986 9.96145 9.05515C9.37831 9.8117 8.5904 10.3851 7.6912 10.7073C6.79199 11.0296 5.81922 11.0871 4.8883 10.8731C3.95738 10.6591 3.10737 10.1826 2.43912 9.50005H4.00012C4.13273 9.50005 4.25991 9.44737 4.35368 9.3536C4.44744 9.25983 4.50012 9.13266 4.50012 9.00005C4.50012 8.86744 4.44744 8.74026 4.35368 8.64649C4.25991 8.55272 4.13273 8.50005 4.00012 8.50005H1.92862C1.80667 8.49998 1.6859 8.52395 1.57322 8.57059C1.46054 8.61723 1.35816 8.68562 1.27193 8.77185C1.18569 8.85808 1.1173 8.96047 1.07067 9.07315C1.02403 9.18583 1.00006 9.3066 1.00012 9.42855V11.5001C1.00012 11.6327 1.0528 11.7598 1.14657 11.8536C1.24034 11.9474 1.36751 12.0001 1.50012 12.0001C1.63273 12.0001 1.75991 11.9474 1.85368 11.8536C1.94744 11.7598 2.00012 11.6327 2.00012 11.5001V10.4611C2.82654 11.2053 3.84383 11.7048 4.93807 11.9037C6.03232 12.1025 7.16031 11.9928 8.19573 11.5868C9.23115 11.1809 10.1331 10.4947 10.8006 9.60509C11.4681 8.71551 11.8748 7.65767 11.9751 6.55004C11.9816 6.48041 11.9735 6.4102 11.9513 6.34388C11.9291 6.27756 11.8934 6.21659 11.8463 6.16485C11.7993 6.11311 11.742 6.07173 11.6781 6.04335C11.6142 6.01498 11.545 6.00023 11.4751 6.00004H11.4756Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_smh_refresh">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

// Иконка фильтра (воронка) — из Figma (node 2230_18933)
const FilterIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_filter)">
      <path d="M6.99999 12C6.89181 12 6.78654 11.9649 6.69999 11.9L4.69999 10.4C4.63789 10.3534 4.58749 10.293 4.55278 10.2236C4.51806 10.1542 4.49999 10.0776 4.49999 10V7.19L0.99199 3.2435C0.74285 2.96244 0.58018 2.61541 0.52353 2.24412C0.466881 1.87283 0.518662 1.49308 0.672652 1.15051C0.826641 0.807938 1.07629 0.517129 1.39158 0.313033C1.70688 0.108936 2.0744 0.000237209 2.44999 0L9.54999 0C9.92554 0.000440525 10.293 0.10932 10.6081 0.313553C10.9233 0.517787 11.1728 0.808686 11.3266 1.15129C11.4805 1.4939 11.5321 1.87364 11.4753 2.24487C11.4185 2.61611 11.2557 2.96305 11.0065 3.244L7.49999 7.19V11.5C7.49999 11.6326 7.44731 11.7598 7.35354 11.8536C7.25978 11.9473 7.1326 12 6.99999 12ZM5.49999 9.75L6.49999 10.5V7C6.50009 6.87758 6.5451 6.75945 6.62649 6.668L10.2605 2.5795C10.3817 2.44254 10.4607 2.27352 10.4882 2.09273C10.5157 1.91193 10.4904 1.72705 10.4154 1.56028C10.3404 1.39351 10.2188 1.25193 10.0653 1.15254C9.91179 1.05316 9.73286 1.00019 9.54999 1H2.44999C2.26722 1.00028 2.0884 1.05327 1.93499 1.15263C1.78158 1.25199 1.66009 1.3935 1.58509 1.56018C1.51009 1.72685 1.48477 1.91163 1.51215 2.09234C1.53954 2.27305 1.61847 2.44203 1.73949 2.579L5.37399 6.668C5.4552 6.75952 5.50003 6.87764 5.49999 7V9.75Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_filter">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

// Иконка подключений (молекула) — из макета Figma
const ShareIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.6666 7.3336C9.2885 7.3339 8.9163 7.4262 8.5818 7.6025C8.2474 7.7788 7.9609 8.0339 7.7471 8.3456L4.4926 6.8761C4.7237 6.3179 4.7246 5.691 4.4951 5.1321L7.7451 3.6551C8.062 4.1135 8.5328 4.4431 9.0719 4.5841C9.611 4.7252 10.1828 4.6683 10.6836 4.4239C11.1845 4.1794 11.581 3.7636 11.8015 3.2518C12.022 2.7399 12.0517 2.1661 11.8853 1.6342C11.7189 1.1024 11.3673 0.647774 10.8945 0.352904C10.4216 0.0580344 9.8587 -0.057586 9.3079 0.0270138C8.757 0.111614 8.2548 0.390834 7.8922 0.814034C7.5296 1.23722 7.3307 1.77636 7.3316 2.33362C7.3337 2.46552 7.3471 2.59702 7.3716 2.72662L3.9166 4.29662C3.5848 3.98572 3.1693 3.77852 2.7214 3.70052C2.2734 3.62252 1.8124 3.67702 1.395 3.85742C0.977601 4.03772 0.622001 4.33612 0.371801 4.71582C0.121601 5.09552 -0.012199 5.54002 -0.013199 5.99472C-0.014199 6.44952 0.117701 6.89462 0.366201 7.27542C0.614701 7.65622 0.969001 7.95612 1.3856 8.13832C1.8022 8.32052 2.263 8.37712 2.7113 8.30102C3.1596 8.22492 3.5759 8.01962 3.9091 7.71012L7.3731 9.27412C7.349 9.40362 7.3358 9.53492 7.3336 9.66662C7.3335 10.1282 7.4703 10.5794 7.7266 10.9632C7.983 11.3471 8.3475 11.6462 8.7739 11.8229C9.2003 11.9996 9.6695 12.0458 10.1222 11.9558C10.5749 11.8658 10.9907 11.6435 11.3171 11.3172C11.6435 10.9908 11.8658 10.5749 11.9558 10.1222C12.0458 9.6695 11.9995 9.2003 11.8229 8.7739C11.6462 8.3475 11.347 7.9831 10.9632 7.7267C10.5794 7.4703 10.1282 7.3335 9.6666 7.3336ZM9.6666 1.00012C9.9304 1.00002 10.1882 1.07815 10.4076 1.22462C10.6269 1.37108 10.7979 1.57931 10.8989 1.82297C10.9999 2.06662 11.0264 2.33482 10.975 2.59352C10.9236 2.85222 10.7967 3.08982 10.6102 3.27642C10.4237 3.46292 10.1861 3.59002 9.9274 3.64152C9.6687 3.69302 9.4006 3.66662 9.1569 3.56572C8.9132 3.46482 8.7049 3.29382 8.5584 3.07452C8.4118 2.85522 8.3336 2.59742 8.3336 2.33362C8.3339 1.98012 8.4744 1.64117 8.7243 1.39117C8.9742 1.14116 9.3131 1.00052 9.6666 1.00012ZM2.3336 7.3336C2.0698 7.3337 1.812 7.2556 1.5926 7.1091C1.3732 6.9627 1.2022 6.7544 1.1012 6.5108C1.0002 6.2671 0.973801 5.999 1.0252 5.7403C1.0765 5.4816 1.2035 5.2439 1.39 5.0574C1.5765 4.8708 1.8141 4.7438 2.0728 4.6923C2.3314 4.6408 2.5996 4.6672 2.8433 4.7681C3.087 4.869 3.2953 5.0399 3.4418 5.2592C3.5884 5.4785 3.6666 5.7364 3.6666 6.0001C3.6662 6.3536 3.5256 6.6925 3.2758 6.9424C3.0259 7.1924 2.687 7.3331 2.3336 7.3336ZM9.6666 11.0001C9.4028 11.0001 9.145 10.9219 8.9257 10.7754C8.7064 10.6289 8.5355 10.4206 8.4346 10.1769C8.3337 9.9333 8.3073 9.6651 8.3587 9.4065C8.4102 9.1478 8.5372 8.9102 8.7237 8.7237C8.9102 8.5372 9.1478 8.4102 9.4064 8.3587C9.6651 8.3073 9.9332 8.3337 10.1769 8.4346C10.4206 8.5356 10.6288 8.7065 10.7754 8.9258C10.9219 9.1451 11.0001 9.4029 11.0001 9.6666C10.9998 10.0202 10.8592 10.3592 10.6092 10.6093C10.3592 10.8593 10.0202 10.9999 9.6666 11.0001Z" fill="currentColor" />
  </svg>
);

// Иконка плюс — из макета Figma
const PlusIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 5.5H6.5V0.5C6.5 0.367392 6.44732 0.240215 6.35355 0.146447C6.25979 0.0526785 6.13261 0 6 0C5.86739 0 5.74022 0.0526785 5.64645 0.146447C5.55268 0.240215 5.5 0.367392 5.5 0.5V5.5H0.5C0.367392 5.5 0.240215 5.55268 0.146447 5.64645C0.0526785 5.74022 0 5.86739 0 6C0 6.13261 0.0526785 6.25979 0.146447 6.35355C0.240215 6.44732 0.367392 6.5 0.5 6.5H5.5V11.5C5.5 11.6326 5.55268 11.7598 5.64645 11.8536C5.74022 11.9473 5.86739 12 6 12C6.13261 12 6.25979 11.9473 6.35355 11.8536C6.44732 11.7598 6.5 11.6326 6.5 11.5V6.5H11.5C11.6326 6.5 11.7598 6.44732 11.8536 6.35355C11.9473 6.25979 12 6.13261 12 6C12 5.86739 11.9473 5.74022 11.8536 5.64645C11.7598 5.55268 11.6326 5.5 11.5 5.5Z" fill="currentColor" />
  </svg>
);

// Иконка редактирования — из Figma (node 2230_3169)
const EditIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_edit)">
      <path d="M9.32801 0.465158L3.23201 6.56116C2.99918 6.79273 2.8146 7.06819 2.68895 7.37158C2.5633 7.67497 2.49908 8.00028 2.50001 8.32866V9.00016C2.50001 9.13277 2.55269 9.25994 2.64646 9.35371C2.74022 9.44748 2.8674 9.50016 3.00001 9.50016H3.67151C3.99989 9.50109 4.32519 9.43687 4.62859 9.31122C4.93198 9.18557 5.20744 9.00099 5.43901 8.76816L11.535 2.67216C11.8272 2.37924 11.9913 1.9824 11.9913 1.56866C11.9913 1.15492 11.8272 0.758073 11.535 0.465158C11.2378 0.181105 10.8426 0.022583 10.4315 0.022583C10.0204 0.022583 9.62517 0.181105 9.32801 0.465158ZM10.828 1.96516L4.73201 8.06116C4.45007 8.34137 4.06901 8.49912 3.67151 8.50016H3.50001V8.32866C3.50105 7.93115 3.65879 7.5501 3.93901 7.26816L10.035 1.17216C10.1418 1.07014 10.2838 1.0132 10.4315 1.0132C10.5792 1.0132 10.7212 1.07014 10.828 1.17216C10.933 1.27742 10.9919 1.42 10.9919 1.56866C10.9919 1.71731 10.933 1.8599 10.828 1.96516Z" fill="currentColor"/>
      <path d="M11.5 4.4895C11.3674 4.4895 11.2402 4.54218 11.1464 4.63595C11.0527 4.72972 11 4.85689 11 4.9895V7.5H9C8.60218 7.5 8.22064 7.65804 7.93934 7.93934C7.65804 8.22064 7.5 8.60218 7.5 9V11H2.5C2.10218 11 1.72064 10.842 1.43934 10.5607C1.15804 10.2794 1 9.89783 1 9.5V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H7.021C7.15361 1 7.28079 0.947322 7.37455 0.853554C7.46832 0.759785 7.521 0.632608 7.521 0.5C7.521 0.367392 7.46832 0.240215 7.37455 0.146447C7.28079 0.0526784 7.15361 0 7.021 0L2.5 0C1.8372 0.000793929 1.20178 0.264441 0.73311 0.73311C0.264441 1.20178 0.000793929 1.8372 0 2.5L0 9.5C0.000793929 10.1628 0.264441 10.7982 0.73311 11.2669C1.20178 11.7356 1.8372 11.9992 2.5 12H8.1715C8.49996 12.0009 8.82534 11.9367 9.12882 11.8111C9.43229 11.6854 9.70784 11.5008 9.9395 11.268L11.2675 9.939C11.5004 9.70744 11.685 9.43199 11.8108 9.1286C11.9365 8.82522 12.0008 8.49991 12 8.1715V4.9895C12 4.85689 11.9473 4.72972 11.8536 4.63595C11.7598 4.54218 11.6326 4.4895 11.5 4.4895ZM9.2325 10.561C9.03151 10.7615 8.77734 10.9003 8.5 10.961V9C8.5 8.86739 8.55268 8.74022 8.64645 8.64645C8.74022 8.55268 8.86739 8.5 9 8.5H10.9625C10.9006 8.77676 10.762 9.03047 10.5625 9.232L9.2325 10.561Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_edit">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

// Иконка удаления (trash) — 12×12 filled
const TrashIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 1V0.5H7.5V1H10.5V2.5H1.5V1H4.5ZM2.5 3.5H9.5V10.5C9.5 11.05 9.05 11.5 8.5 11.5H3.5C2.95 11.5 2.5 11.05 2.5 10.5V3.5ZM4 5V10H5V5H4ZM7 5V10H8V5H7Z" fill="currentColor"/>
  </svg>
);

// Иконка три точки вертикально (more) — 12×12 filled
const MoreIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="2" r="1" fill="currentColor"/>
    <circle cx="6" cy="6" r="1" fill="currentColor"/>
    <circle cx="6" cy="10" r="1" fill="currentColor"/>
  </svg>
);

const BugIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#smh-check-clip)">
      <path d="M11 3.5C11.2652 3.5 11.5196 3.39464 11.7071 3.20711C11.8946 3.01957 12 2.76522 12 2.5V0.5C12 0.367392 11.9473 0.240215 11.8536 0.146447C11.7598 0.0526784 11.6326 0 11.5 0C11.3674 0 11.2402 0.0526784 11.1464 0.146447C11.0527 0.240215 11 0.367392 11 0.5V2.5H9C8.991 2.5 8.984 2.5045 8.975 2.505C8.73585 1.9125 8.32509 1.40499 7.79545 1.04761C7.2658 0.690226 6.64144 0.499281 6.0025 0.499281C5.36356 0.499281 4.7392 0.690226 4.20955 1.04761C3.67991 1.40499 3.26915 1.9125 3.03 2.505C3.0195 2.5055 3.0105 2.5 3 2.5H1V0.5C1 0.367392 0.947322 0.240215 0.853553 0.146447C0.759785 0.0526784 0.632608 0 0.5 0C0.367392 0 0.240215 0.0526784 0.146447 0.146447C0.0526784 0.240215 0 0.367392 0 0.5L0 2.5C0 2.76522 0.105357 3.01957 0.292893 3.20711C0.48043 3.39464 0.734784 3.5 1 3.5H2.7425L2.236 5.5H0.5C0.367392 5.5 0.240215 5.55268 0.146447 5.64645C0.0526784 5.74021 0 5.86739 0 6C0 6.13261 0.0526784 6.25979 0.146447 6.35355C0.240215 6.44732 0.367392 6.5 0.5 6.5H1.9825L1.91 6.7865L1.9 6.85C1.87771 7.02111 1.86602 7.19344 1.865 7.366C1.86551 7.74969 1.91987 8.13142 2.0265 8.5H1C0.734784 8.5 0.48043 8.60536 0.292893 8.79289C0.105357 8.98043 0 9.23478 0 9.5L0 11.5C0 11.6326 0.0526784 11.7598 0.146447 11.8536C0.240215 11.9473 0.367392 12 0.5 12C0.632608 12 0.759785 11.9473 0.853553 11.8536C0.947322 11.7598 1 11.6326 1 11.5V9.5H2.465C2.83155 10.1101 3.34976 10.6149 3.96921 10.9654C4.58866 11.3159 5.28827 11.5001 6 11.5001C6.71173 11.5001 7.41134 11.3159 8.03079 10.9654C8.65024 10.6149 9.16845 10.1101 9.535 9.5H11V11.5C11 11.6326 11.0527 11.7598 11.1464 11.8536C11.2402 11.9473 11.3674 12 11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5V9.5C12 9.23478 11.8946 8.98043 11.7071 8.79289C11.5196 8.60536 11.2652 8.5 11 8.5H9.9735C10.0807 8.13066 10.1354 7.74808 10.136 7.3635C10.1345 7.19176 10.1225 7.02027 10.1 6.85L10.0125 6.5H11.5C11.6326 6.5 11.7598 6.44732 11.8536 6.35355C11.9473 6.25979 12 6.13261 12 6C12 5.86739 11.9473 5.74021 11.8536 5.64645C11.7598 5.55268 11.6326 5.5 11.5 5.5H9.761L9.2565 3.5H11ZM6 10.5C5.16848 10.4991 4.37129 10.1683 3.78336 9.58029C3.19543 8.99227 2.86479 8.19502 2.864 7.3635C2.86469 7.24198 2.87253 7.1206 2.8875 7L3.9025 2.985C4.05483 2.55255 4.33709 2.17775 4.71065 1.91191C5.0842 1.64606 5.53079 1.50217 5.98928 1.49992C6.44777 1.49768 6.89575 1.63719 7.27189 1.89937C7.64803 2.16154 7.93394 2.53356 8.0905 2.9645L9.1125 7C9.12743 7.12027 9.13527 7.24131 9.136 7.3625C9.13547 8.19419 8.80495 8.9917 8.21699 9.57993C7.62904 10.1682 6.83169 10.4991 6 10.5Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="smh-check-clip">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/** Проверка IMEI — barcode + галочка (12×12, как остальные smh-иконки) */
const ImeiCheckIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.5C1 1.22386 1.22386 1 1.5 1H2.5V2H2V10H2.5V11H1.5C1.22386 11 1 10.7761 1 10.5V1.5Z" fill="currentColor"/>
    <path d="M10.5 1C10.7761 1 11 1.22386 11 1.5V10.5C11 10.7761 10.7761 11 10.5 11H9.5V10H10V2H9.5V1H10.5Z" fill="currentColor"/>
    <rect x="3.25" y="2.5" width="1" height="7" rx="0.25" fill="currentColor"/>
    <rect x="5" y="2.5" width="0.75" height="7" rx="0.2" fill="currentColor"/>
    <rect x="6.5" y="2.5" width="1.25" height="4" rx="0.25" fill="currentColor"/>
    <path d="M7.25 8.1L8.15 9L10.35 6.8L9.65 6.1L8.15 7.6L7.95 7.4L7.25 8.1Z" fill="currentColor"/>
  </svg>
);

// Компонент Chip — активный с тёмным фоном
const ChipActive = ({ label, count, onClick }) => (
  <button
    type="button"
    className="smh__chip smh__chip--active"
    onClick={onClick}
    tabIndex={0}
  >
    <span className="smh__chip-label smh__chip-label--light">{label}</span>
    <span className="smh__chip-count smh__chip-count--green">{count}</span>
  </button>
);

// Компонент Chip — неактивный с белым фоном
const ChipInactive = ({ label, count, onClick }) => (
  <button
    type="button"
    className="smh__chip smh__chip--inactive"
    onClick={onClick}
    tabIndex={0}
  >
    <span className="smh__chip-label">{label}</span>
    <span className="smh__chip-count">{count}</span>
  </button>
);

// Компонент Chip — информационный (без клика)
// valueColor: 'red' (#F33F4E) | 'green' (#0CBE90) | default (#383838)
const ChipInfo = ({ label, value, valueColor }) => {
  let countClass = 'smh__chip-count';
  if (valueColor === 'red') countClass += ' smh__chip-count--red';
  else if (valueColor === 'green') countClass += ' smh__chip-count--green';
  
  return (
    <div className="smh__chip smh__chip--inactive smh__chip--info">
      <span className="smh__chip-label">{label}</span>
      <span className={countClass}>{value}</span>
    </div>
  );
};

// Иконка сброса фильтра — 12×12 filled + stroke (как FilterIcon)
const FilterOffIcon = () => (
  <svg className="smh__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 2H7.75L4.5 6.5V9.5L3.5 8.5V6.5L1.5 3.79V2Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.5 4L11 6.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M11 4L8.5 6.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

const Divider = () => <div className="smh__divider" />;

const SimManagerHeader = ({
  title = 'Sim-менеджер',
  // Статусы
  statusCounts = {
    all: 6,
    available: 4,
    unavailable: 1,
    unknown: 1,
  },
  activeStatus = 'all',
  onStatusChange,
  // SIM резервы
  simReserves = [
    { id: 'msk', label: 'Резерв Мск', count: 1 },
    { id: 'spb', label: 'Резерв СПб', count: 1 },
  ],
  activeReserve = null, // 'msk' | 'spb' | null
  onSimReserveClick,
  // Финансы
  totalPayments = '2 140',
  avgTariffPrice = '356,67',
  // Количество выбранных строк (для показа кнопки редактирования)
  selectedCount = 0,
  // Обработчики кнопок
  onRefresh,
  onFilter,
  isFilterActive = false,
  onEdit,
  onExport,
  onExportEsia,
  onAdd,
  onDelete,
  onProxyCheck,
  isProxyChecking = false,
  onImeiCheck,
  isImeiCheckActive = false,
  onMore,
  // Сброс фильтров
  activeFilterCount = 0,
  onClearFilters,
  // Mobile detection
  isMobile = false,
}) => {
  const handleStatusClick = (status) => {
    if (onStatusChange) {
      onStatusChange(status);
    }
  };

  const handleReserveClick = (reserveId) => {
    if (onSimReserveClick) {
      onSimReserveClick(reserveId);
    }
  };

  // Есть ли активный резерв — если да, статусы все неактивны
  const hasActiveReserve = !!activeReserve;

  // Рендер чипа статуса
  const renderStatusChip = (status, label, count) => {
    // Если активен резерв — все статусы неактивны
    if (hasActiveReserve) {
      return (
        <ChipInactive
          key={status}
          label={label}
          count={count}
          onClick={() => handleStatusClick(status)}
        />
      );
    }
    if (activeStatus === status) {
      return <ChipActive key={status} label={label} count={count} onClick={() => handleStatusClick('all')} />;
    }
    return (
      <ChipInactive
        key={status}
        label={label}
        count={count}
        onClick={() => handleStatusClick(status)}
      />
    );
  };

  const renderMobileQuickLink = ({ key, label, count, isActive, onClick }) => (
    <button
      key={key}
      type="button"
      className={`smh__mobile-quick-link${isActive ? ' smh__mobile-quick-link--active' : ''}`}
      onClick={onClick}
      tabIndex={0}
      aria-label={`${label}: ${count}`}
    >
      <span className="smh__mobile-quick-link-label">{label}</span>
      <span className="smh__mobile-quick-link-count">{count}</span>
    </button>
  );

  const renderMobileInfoChip = ({ key, label, value, valueColor }) => (
    <div
      key={key}
      className="smh__mobile-quick-link smh__mobile-quick-link--info"
      aria-label={`${label} ${value}`}
    >
      <span className="smh__mobile-quick-link-label">{label}</span>
      <span
        className={`smh__mobile-quick-link-count ${
          valueColor === 'red'
            ? 'smh__mobile-quick-link-count--red'
            : valueColor === 'green'
              ? 'smh__mobile-quick-link-count--green'
              : ''
        }`}
      >
        {value}
      </span>
    </div>
  );

  return (
    <header className="smh">
      {/* Заголовок */}
      <p className="smh__title">{title}</p>

      {/* Группа бейджей */}
      <div className="smh__badges">
        {/* Блок статусов */}
        <div className="smh__block">
          {renderStatusChip('all', 'Все', statusCounts.all)}
          {renderStatusChip('available', 'Доступно', statusCounts.available)}
          {renderStatusChip('unavailable', 'Недоступно', statusCounts.unavailable)}
          {renderStatusChip('unknown', 'Неизвестно', statusCounts.unknown)}
        </div>

        {/* Блок SIM резервов */}
        <div className="smh__block">
          <Divider />
          <span className="smh__label">SIM</span>
          {simReserves.map((reserve) =>
            activeReserve === reserve.id ? (
              <ChipActive
                key={reserve.id}
                label={reserve.label}
                count={reserve.count}
                onClick={() => handleStatusClick('all')}
              />
            ) : (
              <ChipInactive
                key={reserve.id}
                label={reserve.label}
                count={reserve.count}
                onClick={() => handleReserveClick(reserve.id)}
              />
            )
          )}
        </div>

        {/* Блок финансов */}
        <div className="smh__block">
          <Divider />
          <ChipInfo label="Сумма оплат, ₽:" value={totalPayments} valueColor="red" />
          <ChipInfo label="Ср.цена тарифа, ₽:" value={avgTariffPrice} valueColor="green" />
        </div>
      </div>

      {/* Кнопки */}
      <div className="smh__buttons">
        {/* === Мобильный режим с выбранными строками === */}
        {isMobile && selectedCount > 0 && (
          <button
            type="button"
            className="smh__btn smh__btn--icon-only smh__btn--delete-mobile"
            onClick={onDelete}
            aria-label="Удалить выбранные"
            tabIndex={0}
          >
            <TrashIcon />
          </button>
        )}

        {isMobile && selectedCount > 0 && (
          <button
            type="button"
            className="smh__btn smh__btn--icon-only smh__btn--bulk-edit smh__btn--edit-mobile"
            onClick={onEdit}
            aria-label="Редактировать выбранные"
            tabIndex={0}
          >
            <EditIcon />
          </button>
        )}

        {/* Десктоп: массовые действия — перед «Обновить» */}
        {!isMobile && selectedCount > 0 && (
          <button
            type="button"
            className="smh__btn smh__btn--icon-only smh__btn--delete"
            onClick={onDelete}
            aria-label={`Удалить выбранные (${selectedCount})`}
            tabIndex={0}
            data-tooltip={`Удалить (${selectedCount})`}
          >
            <TrashIcon />
          </button>
        )}

        {!isMobile && selectedCount > 0 && (
          <button
            type="button"
            className="smh__btn smh__btn--icon-only smh__btn--bulk-edit"
            onClick={onEdit}
            aria-label={`Редактировать выбранные (${selectedCount})`}
            tabIndex={0}
            data-tooltip={`Редактировать (${selectedCount})`}
          >
            <EditIcon />
          </button>
        )}

        {(selectedCount > 0 || isProxyChecking) && (
          <button
            type="button"
            className={`smh__btn smh__btn--icon-only smh__btn--bulk-check${isProxyChecking ? ' smh__btn--proxy-checking' : ''}`}
            onClick={onProxyCheck}
            aria-label={
              isProxyChecking
                ? 'Идёт проверка прокси'
                : `Проверить прокси на выбранных SIM (${selectedCount})`
            }
            tabIndex={0}
            data-tooltip={isProxyChecking ? 'Проверка прокси...' : `Проверить прокси (${selectedCount})`}
            disabled={isProxyChecking}
          >
            <BugIcon />
          </button>
        )}

        {/* Кнопка обновления */}
        <button
          type="button"
          className="smh__btn smh__btn--icon-only"
          onClick={onRefresh}
          aria-label="Обновить"
          tabIndex={0}
        >
          <RefreshIcon />
        </button>

        {/* Проверка IMEI SIM ↔ модем */}
        <button
          type="button"
          className={`smh__btn smh__btn--icon-only smh__btn--imei-check${isImeiCheckActive ? ' smh__btn--active' : ''}`}
          onClick={onImeiCheck}
          aria-label={isImeiCheckActive ? 'Сбросить фильтр IMEI' : 'Проверить IMEI'}
          tabIndex={0}
          data-tooltip={isImeiCheckActive ? 'Сбросить фильтр IMEI' : 'Проверить IMEI'}
          title={isImeiCheckActive ? 'Сбросить фильтр IMEI' : 'Проверить IMEI'}
        >
          <ImeiCheckIcon />
        </button>

        {/* Кнопка подключений (экспорт) */}
        <Dropdown
          menu={{
            items: [
              { key: 'export', label: 'Экспорт' },
              { key: 'export-esia', label: 'Экспорт ЕСИА' },
            ],
            onClick: ({ key }) => {
              if (key === 'export-esia') {
                if (onExportEsia) onExportEsia();
                return;
              }
              if (onExport) onExport();
            },
          }}
          trigger={['click']}
          placement="bottomRight"
          overlayClassName="pm-action-dropdown"
        >
          <button
            type="button"
            className="smh__btn smh__btn--icon-only"
            aria-label="Экспорт"
            tabIndex={0}
            data-tooltip="Экспорт"
            title="Экспорт"
          >
            <ShareIcon />
          </button>
        </Dropdown>

        {/* Сброс фильтров */}
        {activeFilterCount > 0 && (
          <button
            type="button"
            className="smh__btn smh__btn--icon-only smh__btn--clear-filters"
            onClick={onClearFilters}
            aria-label={`Сбросить фильтры (${activeFilterCount})`}
            title={`Сбросить фильтры (${activeFilterCount})`}
            tabIndex={0}
          >
            <FilterOffIcon />
          </button>
        )}

        {/* Кнопка фильтра — скрыта на мобильном при выбранных строках */}
        {!(isMobile && selectedCount > 0) && (
          <button
            type="button"
            className={`smh__btn smh__btn--icon-only${isFilterActive ? ' smh__btn--active' : ''}`}
            onClick={onFilter}
            aria-label="Фильтр"
            tabIndex={0}
          >
            <FilterIcon />
          </button>
        )}

        {/* Кнопка добавить — скрыта на мобильном при выбранных строках */}
        {!(isMobile && selectedCount > 0) && (
          <button
            type="button"
            className="smh__btn smh__btn--add"
            onClick={onAdd}
            aria-label="Добавить"
            tabIndex={0}
          >
            <span className="smh__btn-text">Добавить</span>
            <PlusIcon />
          </button>
        )}

        {/* Кнопка "Ещё" (три точки) — мобильный, только при выбранных */}
        {isMobile && selectedCount > 0 && (
          <button
            type="button"
            className="smh__btn smh__btn--icon-only smh__btn--more-mobile"
            onClick={onMore}
            aria-label="Ещё"
            tabIndex={0}
          >
            <MoreIcon />
          </button>
        )}
      </div>

      {/* Быстрые ссылки (mobile) */}
      {isMobile && (
        <div className="smh__mobile-quick-links" aria-label="Быстрые фильтры SIM">
          <div className="smh__mobile-quick-group" aria-label="Статусы и резервы">
            {renderMobileQuickLink({
              key: 'all',
              label: 'Все',
              count: statusCounts.all,
              isActive: !hasActiveReserve && activeStatus === 'all',
              onClick: () => handleStatusClick('all'),
            })}
            {renderMobileQuickLink({
              key: 'available',
              label: 'Доступно',
              count: statusCounts.available,
              isActive: !hasActiveReserve && activeStatus === 'available',
              onClick: () => handleStatusClick('available'),
            })}
            {renderMobileQuickLink({
              key: 'unavailable',
              label: 'Недоступно',
              count: statusCounts.unavailable,
              isActive: !hasActiveReserve && activeStatus === 'unavailable',
              onClick: () => handleStatusClick('unavailable'),
            })}
            {renderMobileQuickLink({
              key: 'unknown',
              label: 'Неизвестно',
              count: statusCounts.unknown,
              isActive: !hasActiveReserve && activeStatus === 'unknown',
              onClick: () => handleStatusClick('unknown'),
            })}
            {simReserves.map((reserve) =>
              renderMobileQuickLink({
                key: reserve.id,
                label: reserve.label,
                count: reserve.count,
                isActive: activeReserve === reserve.id,
                onClick: () => (
                  activeReserve === reserve.id
                    ? handleStatusClick('all')
                    : handleReserveClick(reserve.id)
                ),
              })
            )}
          </div>

          <div className="smh__mobile-quick-group smh__mobile-quick-group--finance" aria-label="Финансы">
            {renderMobileInfoChip({
              key: 'total-payments',
              label: 'Сумма, ₽',
              value: totalPayments,
              valueColor: 'red',
            })}
            {renderMobileInfoChip({
              key: 'avg-tariff',
              label: 'Ср.тариф, ₽',
              value: avgTariffPrice,
              valueColor: 'green',
            })}
          </div>
        </div>
      )}
    </header>
  );
};

export default SimManagerHeader;
